import React from 'react';
import { SvgIcon } from '@mui/material';
import { iconType } from './icon-types';

const UploadIcon = (properties: iconType) => (
  <SvgIcon {...properties} viewBox="0 0 16 20" style={{ width: '16px', height: '20px' }}>
    <path d="M8.83318 16.6665L6.16651 16.6665L6.16651 10.9522L8.83318 10.9522L8.83318 16.6665Z" />
    <path d="M7.49972 6.6665L4.16639 12.3808L10.8331 12.3808L7.49972 6.6665Z" />
    <path d="M1.58333 20H14.25C15.1208 20 15.8333 19.2742 15.8333 18.3871V7.95161C15.8333 7.51613 15.675 7.1129 15.3742 6.80645L9.15167 0.467742C8.85083 0.16129 8.455 0 8.0275 0H1.58333C0.7125 0 0 0.725806 0 1.6129V18.3871C0 19.2742 0.7125 20 1.58333 20ZM0.632324 1.61307C0.632324 1.08081 1.05982 0.645325 1.58232 0.645325H8.02649C8.27982 0.645325 8.51732 0.742099 8.69149 0.935647L14.914 7.27436C15.104 7.45178 15.199 7.69371 15.199 7.95178V18.3873C15.199 18.9195 14.7715 19.355 14.249 19.355H1.58232C1.05982 19.355 0.632324 18.9195 0.632324 18.3873V1.61307Z" />
  </SvgIcon>
);

UploadIcon.defaultProperties = {
  fill: '#969696',
};

export default UploadIcon;
